<template>
    <v-dialog :value="value" max-width="660" scrollable @input="$emit('input', $event)">
        <v-card dir="rtl" class="rounded-lg">
            <div class="cmt-head">
                <v-icon small color="white" class="me-2">mdi-comment-text-multiple-outline</v-icon>
                <span>{{ $t('Comments') }}</span>
                <span v-if="reference" class="cmt-ref">{{ reference }}</span>
                <v-spacer />
                <v-btn icon dark @click="$emit('input', false)"><v-icon>mdi-close</v-icon></v-btn>
            </div>
            <v-card-text class="pa-4" style="max-height:62vh;">
                <v-progress-linear v-if="loading" indeterminate color="primary" />
                <div v-else-if="!comments.length" class="text-center py-8" style="color:#90a4ae;">
                    <v-icon size="42" color="#cfd8dc">mdi-comment-remove-outline</v-icon>
                    <div class="mt-2">{{ $t('NoComments') }}</div>
                </div>
                <div v-for="(c, i) in comments" :key="i" class="cmt-item" :class="'cmt--' + actionOf(c)">
                    <div class="cmt-meta">
                        <v-icon x-small class="me-1" color="#1B8354">mdi-account-circle-outline</v-icon>
                        <span class="cmt-author">{{ c.createdBy }}</span>
                        <!-- action badge; omitted on comments saved before the action was recorded -->
                        <span v-if="c.actionType" class="cmt-badge" :class="'cmt-badge--' + actionOf(c)">
                            <v-icon class="cmt-badge-ic">{{ actionIcon(c) }}</v-icon>
                            {{ $t('Action' + c.actionType) }}
                        </span>
                        <span class="cmt-date">{{ c.createdDate | formatDateTimeGregorian }}</span>
                    </div>
                    <div class="cmt-text">{{ c.text }}</div>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: 'CommentsDialog',

        props: {
            value: {
                type: Boolean,
                default: false
            },
            comments: {
                type: Array,
                default: () => []
            },
            loading: {
                type: Boolean,
                default: false
            },
            // optional badge in the header (the process reference number)
            reference: {
                type: String,
                default: ''
            }
        },

        methods: {
            // 'complete' | 'rework' | 'close' | 'note' | 'unknown' (comments saved before ActionType existed)
            actionOf(c) {
                return (c && c.actionType ? String(c.actionType) : 'unknown').toLowerCase()
            },

            actionIcon(c) {
                return {
                    complete: 'mdi-checkbox-marked',
                    rework: 'mdi-arrow-right-top-bold',
                    close: 'mdi-close-box-outline',
                    note: 'mdi-comment-plus-outline'
                }[this.actionOf(c)] || 'mdi-comment-text-outline'
            }
        }
    }
</script>

<style scoped>
    .cmt-head {
        display: flex; align-items: center; font-weight: 700; font-size: 14.5px; color: #fff;
        padding: 12px 18px; background: linear-gradient(135deg, #1B8354 0%, #28a06a 100%);
    }
    .cmt-ref { background: rgba(255,255,255,.22); border-radius: 6px; padding: 1px 9px; font-size: 12px; margin-inline-start: 12px; }
    .cmt-item {
        background: #f7f9fb; border: 1px solid #edf1f5; border-inline-start: 3px solid #1B8354;
        border-radius: 10px; padding: 11px 14px; margin-bottom: 10px;
    }
    .cmt-meta { display: flex; align-items: center; flex-wrap: wrap; gap: 6px; font-size: 12px; color: #607d8b; margin-bottom: 6px; }
    .cmt-author { font-weight: 700; color: #37474f; }
    .cmt-date { margin-inline-start: auto; color: #90a4ae; }

    /* action badge — palette reused from the section chips and the blocking notice */
    .cmt-badge {
        display: inline-flex; align-items: center; gap: 4px;
        border-radius: 20px; padding: 2px 10px 2px 8px;
        font-size: 11px; font-weight: 700; line-height: 1.7;
        border: 1px solid transparent;
    }
    .cmt-badge-ic { font-size: 13px !important; color: inherit !important; }

    .cmt-badge--complete { background: #e9f4ef; color: #1B8354; border-color: #d3ebe0; }
    .cmt-badge--rework   { background: #fdf5f4; color: #c0392b; border-color: #f0cdc8; }
    .cmt-badge--close    { background: #eceff1; color: #546e7a; border-color: #dde3e6; }
    .cmt-badge--note     { background: #f7f9fb; color: #607d8b; border-color: #dde3e6; }

    /* the accent bar echoes the badge so the action reads at a glance while scanning */
    .cmt--rework { border-inline-start-color: #c0392b !important; }
    .cmt--close  { border-inline-start-color: #546e7a !important; }
    .cmt--note   { border-inline-start-color: #607d8b !important; }
    .cmt-text { font-size: 13.5px; color: #22323d; line-height: 1.7; white-space: pre-wrap; }
</style>
